<template>
  <div id="app">
    <!-- 一级路由  视图位置 -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
    <!-- <router-view></router-view> -->
    <van-popup
      class="van_popup"
      position="bottom"
      :style="{ height: '30%' }"
      v-model="popupShow"
      round
      :overlay="false"
      closeable
      close-icon-position="top-left"
    >
      <div>
        <span>告警信息</span>
        <van-button
          size="mini"
          color="linear-gradient(to right, #ff6034, #ee0a24)"
          @click="towaning"
        >
          现在处理
        </van-button>
      </div>

      <div class="groupbox">
        <van-cell-group>
          <van-cell
            v-for="i in popupData"
            :key="i"
            title="告警信息"
            :label="i"
          />
        </van-cell-group>
      </div>
    </van-popup>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import store from "@/store";
export default {
  data() {
    return {
      popupShow: false,
      popupData: [],
      onopenTag: null,
      WebSocket: null,
    };
  },
  updated() {
    if (store.state.user.access_token && this.onopenTag == false) {
      this.POSTwebsite();
    }
    if (!store.state.user.access_token) {
      this.onopenTag = false;
      if (this.WebSocket !== null) {
        this.WScoles();
      }
    }
    this.Message == 0
      ? ((this.popupShow = false), (this.popupData = null))
      : null;
  },
  computed: {
    ...mapGetters({
      Message: "warnLog/getselectList",
    }),
  },
  // beforeDestroy() {
  //   this.onopenTag = false;
  //   this.WScoles();
  // },
  // destroyed() {
  //   this.onopenTag = false;
  //   this.WScoles();
  // },
  mounted() {
    this.popupShow = false;
    // this.POSTwebsite();
  },
  methods: {
    // ...mapActions({
    //   ActionwarnLogMessage: "warnLog/ActionwarnLogMessage",
    // }),
    // WScoles() {
    //   this.WebSocket.close();
    // },
    // 跳转路由
    towaning() {
      this.$router.push({
        path: "/safelyDetail",
        query: {
          warnitem: "",
        },
      });
      this.popupShow = false;
    },
    POSTwebsite() {
      if ("WebSocket" in window) {
        this.WebSocket = new WebSocket(
          "ws://49.4.83.120:8200/sansint-energy/yqdzSansint/" + this.$token
        );
        //连接回调
        this.WebSocket.onopen = () => {
          this.ActionwarnLogMessage();
          this.onopenTag = true;
          console.log("WebSocket连接成功");
        };
        //发生错误回调
        this.WebSocket.onerror = (e) => {};
        //接收到消息的回调函数
        this.WebSocket.onmessage = (e) => {
          if (e.data != "" && !e.data.includes("有新窗口开始监听")) {
            if (this.popupShow == false) {
              this.popupShow = true;
            }
            JSON.parse(e.data).map((item) => {
              this.popupData.push(
                item.areaName + "---" + item.branchName + ":" + item.title
              );
            });
          }
        };
        // 连接关闭时的回调函数
        this.WebSocket.onclose = (e) => {};
      } else {
        alert("not error  不支持websocket");
      }
    },
  },
};
</script>
<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  font-size: 14px;
  overflow-x: hidden;
  overflow-x: auto;
}
.my-wrapper {
  background-color: rgba(244, 246, 250, 1);
}
#nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
.groupbox {
  margin-top: 0.8rem;
  overflow-y: auto;
  height: 88%;
  box-sizing: border-box;
}
.van_popup {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  box-shadow: 0 2px 3px 5px #e0e0e0;
  & > div:first-child {
    color: red;
    font-size: 16px;
    background-color: #fff;
    box-shadow: 1px 1px 1px 1px #e9e9e9;
    width: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    height: 40px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: absolute;

    & > span {
      line-height: 40px;
    }
  }
}
.van-cell__label {
  word-wrap: break-word;
  word-break: break-all;
}
.van-icon.van-icon-cross.van-popup__close-icon.van-popup__close-icon--top-left {
  top: 0.2rem;
}
</style>
